import { BehaviorSubject } from 'rxjs';

const goldenDuelRulesModal$ = new BehaviorSubject(false);

const displayGoldenDuelRulesModal = (isShow: boolean) => {
	goldenDuelRulesModal$.next(isShow);
}

export const goldenDuelModalService = {
	goldenDuelRulesModal$: goldenDuelRulesModal$.asObservable(),
	displayGoldenDuelRulesModal
};